/* eslint-disable react/prop-types */
/* eslint-disable react/no-danger */
/* eslint-disable react/jsx-child-element-spacing */
import React from 'react'
import styled from 'styled-components'
import DesfazerCancelamento from '../../components/DesfazerCancelamento/DesfazerCancelamento'

import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'

import Button from '@taglivros/oef_componentes/build/components/button'

const WrapperRenewPlan = styled.div`
  background: ${( { type } ) => type === 'Curadoria' ? '#F2FFFF;' : '#FFF7EF'};
  background: ${( { color } ) => color === '#B72133' ? '#FEF8FA': ''};
  padding: 30px 0;
  margin: 10px 0;
  .icon-text {
    margin: 0 34px 20px 34px;
    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      margin: 0 23px 20px 23px;
    }
    align-items: center;
    display: flex;

    svg {
      filter: ${( { color } ) => color === '#B72133' ? 'invert(35%) sepia(95%) saturate(3921%) hue-rotate(335deg) brightness(71%) contrast(103%)' : ''};
    }

    p {
      margin: 0;
      max-width: 90%;
      padding-left: 20px;
      font-size: 16px;
      color: ${( { color } ) => color};
    }
  }

  .renew-button {
    display: flex;
    justify-content: center;

    > button {
      width: 90%;
    }
  }
`

const RenewPlan = ( { type, mensagem, getDados, tituloModalidade, oferecerCancelarSolicitacaoCancelamento } ) => {
  return (
    <WrapperRenewPlan
      color={ mensagem.color || '#1B2A68' }
      type={ type }
    >
      <div className="icon-text">
        {mensagem.icon}

        <p dangerouslySetInnerHTML={{ '__html': mensagem.texto }} />
      </div>

      <div className="renew-button">
        {oferecerCancelarSolicitacaoCancelamento ?
          <DesfazerCancelamento
            getDados={ getDados }
            onlyButton={ true }
            tema={ type === 'Curadoria' ? Button.BOTAO_CURADORIA : Button.BOTAO_INEDITOS }
            tituloModalidade={ tituloModalidade }
          />
          :
          <Button
            onClick={ () => mensagem.handleClick() }
            tema={ type === 'Curadoria' ? Button.BOTAO_CURADORIA : Button.BOTAO_INEDITOS }
            testId={ mensagem.testId }
          >
            {mensagem.acao}
          </Button> }
      </div>
    </WrapperRenewPlan>
  )
}

RenewPlan.propTypes = {
  'mensagem': String.isRequired,
  'type': String.isRequired,
}

export default RenewPlan
